// One Pre/PostTest cell. A test row exists (score 0) from the moment the
// student opens the subject, so `done === false` -- not a 0 score -- is what
// says "not taken yet"; with a max score of 0 the unit has no test at all
// (the row copies CourseOutlineUnit.preTestExpectScore). Anything else (true,
// or a null/undefined flag) shows the score as before.
export const NO_TEST = '-';

export const formatTestScore = function (score, maxScore, done, notTakenText) {
  if (done === false) {
    return maxScore === 0 ? NO_TEST : notTakenText;
  }
  return `${score}/${maxScore}`;
};
